import React from 'react'
import { useTranslation } from 'react-i18next'
import { StatusCaption } from './StatusCaption'

export function BiStateItemContent ({ status }) {
  const { t } = useTranslation()
  const interpolationArgs = {
    deliveryPointNumber: status.singleByType? '' : status.deliveryPointNumber,
    intermediatePointNumber: status.singleByType? '' : status.intermediatePointNumber
  }

  return (
    <>
      <StatusCaption variant={status.status === 'TO_DO' ? 'light' : 'dark'}>
        {t(`order.details.progressBar.${status.type}.inProgress`, interpolationArgs)}
      </StatusCaption>
      <StatusCaption variant={status.status === 'DONE' ? 'dark' : 'light'}>
        {t(`order.details.progressBar.${status.type}.done`, interpolationArgs)}
      </StatusCaption>
    </>
  )
}
